import { CircleCheckIcon, CircleCheckSolidIcon } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { TaskStatus } from './Decoder';

interface Props {
  iconStatus: TaskStatus;
}

function TaskStatusIcon({ iconStatus }: Props) {
  switch (iconStatus) {
    case 'complete':
      return <CircleCheckSolidIcon color="teal" size="lg" />;
    case 'incomplete':
      return <CircleCheckIcon color="gray" size="md" />;
  }
}

export default observer(TaskStatusIcon);
